import SalviaLayout from "@/components/SalviaLayout";
import { useAuth } from "@/_core/hooks/useAuth";
import { trpc } from "@/lib/trpc";
import { usePageTitle } from "@/hooks/usePageTitle";
import { KPICard, KPICardRow, PipelineChart, QualifierChart, CampaignSummaryChart, KMinBanner } from "@/components/dashboard";
import { Card } from "@/components/ui/card";
import { AlertTriangle, Building2, FileText, Activity, CheckCircle2 } from "lucide-react";
import { IndicatorManualModal } from "@/components/home";

export default function RHCockpit() {
  usePageTitle("Cockpit RH");
  const { user } = useAuth();
  const { data, isLoading, error } = trpc.dashboards.rh.cockpit.useQuery(undefined, {
    enabled: !!user && user.role === "client_rh",
    refetchOnWindowFocus: false,
  });

  if (error) {
    return (
      <SalviaLayout title="Dashboard — Cockpit RH">
        <Card className="p-8 text-center">
          <AlertTriangle className="mx-auto mb-4 text-destructive" size={48} />
          <p className="text-muted-foreground">{error.message}</p>
        </Card>
      </SalviaLayout>
    );
  }

  const loading = isLoading || !data;

  return (
    <SalviaLayout title="Dashboard — Cockpit RH">
      <div className="space-y-6">
        {data?.kMin && <KMinBanner kMin={data.kMin} />}

        <KPICardRow>
          <KPICard
            label="Avaliações"
            value={data?.cards.totalEvaluations ?? 0}
            icon={Activity}
            iconColor="text-violet-600"
            iconBg="bg-violet-100"
            loading={loading}
            tooltipKey="totalAvaliacoes"
          />
          <KPICard
            label="Concluídas"
            value={data?.cards.concluidas ?? 0}
            icon={CheckCircle2}
            iconColor="text-emerald-600"
            iconBg="bg-emerald-100"
            subtitle={data?.cards.totalEvaluations ? `${Math.round((data.cards.concluidas / data.cards.totalEvaluations) * 100)}% do total` : undefined}
            loading={loading}
            tooltipKey="avaliacoesConcluidas"
          />
          <KPICard
            label="Setores"
            value={data?.cards.totalSectors ?? 0}
            icon={Building2}
            iconColor="text-blue-600"
            iconBg="bg-blue-100"
            loading={loading}
            tooltipKey="totalSetores"
          />
          <KPICard
            label="Documentos"
            value={data?.cards.docsReady ?? 0}
            icon={FileText}
            iconColor="text-green-600"
            iconBg="bg-green-100"
            loading={loading}
            tooltipKey="documentos"
          />
        </KPICardRow>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <PipelineChart
            pipeline={data?.pipeline ?? {}}
            title="Pipeline de Avaliações"
            loading={loading}
          />
          <QualifierChart
            data={data?.qualifierDistribution ?? []}
            title="Qualificadores"
            loading={loading}
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <QualifierChart
            data={data?.classificationDistribution ?? []}
            title="Classificação de Risco (P×S)"
            loading={loading}
          />
          <CampaignSummaryChart
            campaigns={data?.campaigns ?? {}}
            title="Campanhas da Empresa"
            loading={loading}
          />
        </div>
      </div>
      <IndicatorManualModal profile="rh" />
    </SalviaLayout>
  );
}
